/**
 * « Staff » = agent Digital Team : traitant ET utilisateur du client 3. L'API
 * le calcule (`is_dt_agent` de /api/me/full, même critère que isDtAgent côté
 * API) ; le drapeau `traitant` seul ne suffit pas, rien dans la base du V1 ne
 * le réserve à Digital Team. Un utilisateur d'un autre client marqué traitant
 * voit l'interface client.
 *
 * Champ absent (API ancienne, utilisateur non chargé) : pas staff.
 */
export function isDtStaff(user: { is_dt_agent?: boolean } | null | undefined): boolean {
  return user?.is_dt_agent === true;
}
